import { TypedDispatch, TypedThunk } from "App/Store";
import { BRACKET_STANDING_ACTION } from "core/constants/Actions";
import { bracketStandings } from "core/services/Bracket";

export function bracketStandingDetails(tournamentId: string | number): TypedThunk {
  return async (dispatch: TypedDispatch): Promise<void> => {
    dispatch({ type: BRACKET_STANDING_ACTION.REQUEST });
    const apiResponse = await bracketStandings(tournamentId);
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: BRACKET_STANDING_ACTION.SUCCESS,
        payload: {
          standings: apiResponse.data.standings,
        },
      });
    } else {
      dispatch({
        type: BRACKET_STANDING_ACTION.FAILURE,
      });
    }
  };
}
